import { render, staticRenderFns } from "./modeControl.vue?vue&type=template&id=53019606&scoped=true"
import script from "./modeControl.vue?vue&type=script&lang=js"
export * from "./modeControl.vue?vue&type=script&lang=js"
import style0 from "./modeControl.vue?vue&type=style&index=0&id=53019606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53019606",
  null
  
)

export default component.exports